<template>
    <el-dialog :visible.sync="show" width="300px" center="true">
        <div class="tree-con">
            <el-tree :data="categoryTree" :props="defaultProps" @node-click="handleNodeClick" v-loading="treeLoading"></el-tree>
        </div>
        <div slot="footer">
            <el-button type="success" @click="show = false">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import apis from "@/config/apis";
export default {
  data() {
    return {
      selectData: null,
      origin_type: "self_build",
      defaultProps: {
        children: "children",
        label: "label"
      },
      treeLoading: false,
      categoryTree: []
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getData() {
      this.treeLoading = true;
      let type = this.origin_type === "self_build" ? 1 : 0;
      this.$axios.get(apis.category_tree + "/" + type).then(res => {
        res.data.data = res.data.data.splice(1, res.data.data.length);
        this.categoryTree = res.data.data;
        this.treeLoading = false;
      });
    },
    handleNodeClick(data) {
      this.selectData = data;
    }
  },
  watch: {
    show: function(value) {
      if (value) {
        this.getData();
      } else {
        this.$emit("close", this.selectData);
      }
    }
  }
};
</script>

<style>
.tree-con {
  border: 1px solid #e1e1e1;
}
.submit-center {
  text-align: center;
}
</style>
